import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Apps, { RestrictedRoute } from 'codeArt/external/containers/Apps';
import Root from 'codeArt/external/Root';
import reducers from './reducers/index';
import sagas from './sagas/index';

import './style';


import MainApp from 'app/index';
import AdminApp from 'app-a/index';
import Extra from 'extra/index';

import './global';
import useDisableBackspaceNavigation from '@sinouiincubator/use-disable-backspace-navigation';
import { Storage } from 'codeArt/common';

const config={
  name:"智慧工厂",//站点名称
  rewrite:{
    auth:"/app/board/home",//用户登录后，如果没有输入具体路径，那么默认访问的地址
    unauth:"/signin" //用户未登录，如果没有输入具体路径，那么默认访问的地址
  }
}

Storage.version="1.0";

Root((props) => {
  let { match } = props;
  useDisableBackspaceNavigation();
  return (
    //如果没有指定地址， auth:用户登录后，默认访问的地址,unauth:用户未登录，默认访问的地址
    <Apps {...props} config={config}>
      <Switch>
        <RestrictedRoute path={`${match.url}app-a`} component={AdminApp} />
        <RestrictedRoute path={`${match.url}app`} component={MainApp} />
        <Route component={Extra} />
      </Switch>
    </Apps>
  )
},reducers,sagas);